const membersTransferResources = {
    labelAccessType: 'Access Type',
    labelEmployeeName: 'Employee Name',
    labelPlans: 'Plans',
    labelFacilityFromName: 'Facility Name From',
    labelFacilityFromID: 'Facility ID From',
    labelFacilityToName: 'Facility Name To',
    labelFacilityToID: 'Facility ID To',
    labelKeyfobAccessPass: 'Access Pass',
    labelTransferStatus: 'Status',
    labelTransferReason: 'Reason',
    title: 'Members',
    defaultSortColumn: 'memberFirstName',
    accessorAccessType: 'facilityMemberID',
    accessorEmployeeName: 'memberFirstName',
    accessorFacilityFromName: 'facilityFromName',
    accessorFacilityFromIDNumber: 'facilityFromIDNumber',
    accessorFacilityToName: 'facilityToName',
    accessorFacilityToIDNumber: 'facilityToIDNumber',
    accessorTransferStatus: 'transferStatus',
    accessorTransferReason: 'transferMessage',
    accessorPlanName: 'planName',
    transferButtonText: 'Transfer',
    backToMemberButtonText: 'Back To Member Page',
    labelSelectFacility: 'Please select facility to:',
    placeholderSelectFacility: 'Search by Facility ID, Facility name',
    warnMessageClosingFacility: 'has the "Closing" status. If you select this facility, members will be transferred into closed facility.'
};
export default membersTransferResources;
